import { http } from 'src/config';
import { FUNCDateToString } from 'src/config/function';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setDataKonfigurasiAplikasis = () => {
    loadingBar(true);
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetApplSettings`).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_KONFIGURASI_APLIKASIS', payload: data.Data });
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error');
            }
        })
    }
}

export const setDataKonfigurasiAplikasi = (code) => {
    loadingBar(true);
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetApplSetting?Code=${code}`).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch(setFormKonfigurasiAplikasi('Code', data.Data.Code));
                dispatch(setFormKonfigurasiAplikasi('Name', data.Data.Name));
                dispatch(setFormKonfigurasiAplikasi('ValueType', data.Data.ValueType));
                dispatch(setFormKonfigurasiAplikasi('ValueDate', new Date(data.Data.ValueDate)));
                dispatch(setFormKonfigurasiAplikasi('ValueNumber', data.Data.ValueNumber));
                dispatch(setFormKonfigurasiAplikasi('ValueString', data.Data.ValueString));

                let _label = null;
                let _value = data.Data.ValueType;
                
                if (data.Data.ValueType === 1) {
                    _label = 'DATE';
                }
                if (data.Data.ValueType === 2) {
                    _label = 'NUMBER';
                }
                if (data.Data.ValueType === 3) {
                    _label = 'STRING';
                }
                
                const SELECTVALUE = {
                    label: _label,
                    value: _value
                }
                dispatch(setFormKonfigurasiAplikasi('DataValueTypes', SELECTVALUE));
                dispatch({ type: 'IS_TYPE_KONFIGURASI_APLIKASI', payload: _value });
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error');
            }
        })
    }
}

export const setFormKonfigurasiAplikasi = (formType, formValue) => {
    return {type: 'FORM_KONFIGURASI_APLIKASI', formType, formValue}
}


export const apiAddKonfigurasiAplikasi = (iData) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();

        fd.append('Code', iData.Code);
        fd.append('Name', iData.Name);
        fd.append('ValueType', iData.DataValueTypes.value);
        fd.append('ValueDate', iData.ValueDate);
        fd.append('ValueNumber', iData.ValueNumber);
        fd.append('ValueString', iData.ValueString);

        http.post(`${URLSVC}/Webs/AddApplSetting`,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `Anda telah berhasil menambah data`, 'success').then(function() {
                    dispatch({ type: 'MODAL_KONFIGURASI_APLIKASI', payload: false });
                    dispatch(setDataKonfigurasiAplikasis());
                });
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error');
            }
        })
    }
}

export const apiUpdateKonfigurasiAplikasi = (iData) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();

        fd.append('Code', iData.Code);
        fd.append('Name', iData.Name);
        fd.append('ValueType', iData.DataValueTypes.value);
        fd.append('ValueDate', FUNCDateToString(iData.ValueDate));
        fd.append('ValueNumber', iData.ValueNumber);
        fd.append('ValueString', iData.ValueString);

        http.post(`${URLSVC}/Webs/EditApplSetting`,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `Anda telah berhasil memperbarui data`, 'success').then(function() {
                    dispatch({ type: 'MODAL_KONFIGURASI_APLIKASI', payload: false });
                    dispatch(setDataKonfigurasiAplikasis());
                });
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error');
            }
        })
    }
}

export const apiDeleteKonfigurasiAplikasi = (code, nama) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan hapus konfigurasi (${nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                loadingBar(true);
                http.post(`${URLSVC}/Webs/DeleteApplSetting?Code=${code}`).then((res) => {
                    loadingBar(false);
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil hapus konfigurasi (${nama})`, 'success').then(function() {
                            dispatch(setDataKonfigurasiAplikasis());
                        });
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error');
                    }
                })
            }
        })
    }
}